import script from "./SkeletonBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonBox.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonBox.vue?vue&type=style&index=0&id=6ae3f2ba&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae3f2ba"]])

export default __exports__